import { createSelector } from 'reselect'
import { Country } from 'utils/constants'

// UTILS //
export const getCountryCode = (auDomains, nzDomains) => {
  const hostName = window.location.hostname

  let countryCode = Country.UNKNOWN
  if (auDomains?.includes(hostName)) {
    countryCode = Country.AU
  } else if (nzDomains?.includes(hostName)) {
    countryCode = Country.NZ
  }

  return countryCode
}

// SELECTORS //
export const selectConfiguration = (state) => state.configuration
export const selectCountryCode = (state) => getCountryCode(state.configuration.auDomains, state.configuration.nzDomains)

// RE-SELECTORS //
export const getConfigurationSelector = createSelector(
  [selectConfiguration],
  (configuration) => (configuration)
)

export const getGoogleMapUrl = createSelector(
  [selectConfiguration],
  ({ googleMapUrl }) => (googleMapUrl)
)

export const getToInitializeCookieSelector = createSelector(
  [selectConfiguration],
  ({ toInitializeCookie }) => (toInitializeCookie)
)

export const getWebSocketHostSelector = createSelector(
  [selectConfiguration],
  ({ webSocketHost }) => (webSocketHost)
)

export const getCountryCodeSelector = createSelector(
  [selectConfiguration],
  ({ auDomains, nzDomains }) => getCountryCode(auDomains, nzDomains)
)
